import { defineComponent as _defineComponent } from 'vue'
import NavItem from './NavItem.vue'

interface MenuItem {
  label: string
  icon?: string
  href: string
  target: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpPopover',
  setup(__props) {

const menuItems: MenuItem[] = [
  {
    label: 'Support',
    href: 'https://ironsight.app/support-resources',
    target: '_blank',
  },
  {
    label: 'Terms',
    href: 'https://ironsight.app/terms-of-use',
    target: '_blank',
  },
  {
    label: 'Privacy',
    href: 'https://ironsight.app/privacy-policy',
    target: '_blank',
  },
]

return { __sfc: true,menuItems, NavItem }
}

})